/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  padding: var(--padding);
  color: var(--color);
  font-weight: var(--nve-ref-font-weight-regular);
  font-size: var(--nve-ref-font-size-200);
  flex-grow: 1;
  contain: none;
}
